import { globalStyles } from "@client/shared/constants";

const style = {
  pageTitleWrapper: {
    borderRadius: 2,
  },
  tabPaper: {
    borderRadius: 0,
  },
  tableContainer: {
    "border-radius": "10px",
  },
};

export default style;
